import { render, staticRenderFns } from "./AceptarDemanda.vue?vue&type=template&id=c85daec2&scoped=true"
import script from "./AceptarDemanda.vue?vue&type=script&lang=ts"
export * from "./AceptarDemanda.vue?vue&type=script&lang=ts"
import style0 from "./AceptarDemanda.vue?vue&type=style&index=0&id=c85daec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85daec2",
  null
  
)

export default component.exports